
























































import {
  defineComponent,
  ref,
  computed,
} from '@vue/composition-api';

import {
  getStockLocations,
  deleteStockLocation,
} from '@/api/index';
import categoryOption from '@/table/Store/category';
import useAuth from '@/use/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonModalWithStockLocationEditor from '@/components/Setting/CommonModalWithStockLocationEditor.vue';

const Category = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    CommonModalWithStockLocationEditor,
  },
  // props: {},
  setup(props, { root }) {
    const refetchQuery = ref(false);
    const total = ref(0);
    const editStockLocationModal = ref(null);
    const deleteStockLocationModal = ref(null);

    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    function handlerTableFetched(data: any) {
      total.value = data.total;
    }

    async function deleteStockLocationAction(id: number) {
      await deleteStockLocation(id);
      refetchQuery.value = true;
    }

    const computedFilter = computed(() => {
      const output: { [key: string]: any } = {};

      return output;
    });

    return {
      refetchQuery,
      getStockLocations,
      categoryOption,
      computedFilter,
      hasPermission,
      editStockLocationModal,
      deleteStockLocationModal,

      deleteStockLocationAction,

      total,
      handlerTableFetched,
    };
  },
});

export default Category;
